<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div>
        <a-menu
            v-model:selectedKeys="state.selectedKeys"
            mode="inline"
            theme="dark"
            :open-keys="state.openKeys"
            @click="clickMenuItem"
            @openChange="onOpenChange"
        >
            <template v-for="item in list" :key="item.key">
                <template v-if="!item.children">
                    <router-link :to="item.link">
                        <a-menu-item :key="item.key">
                            <template #icon>
                                <component :is="$antIcons[item.icon]"></component>
                            </template>
                            {{ $t(`${item.title_lang}`) }}
                        </a-menu-item>
                    </router-link>
                </template>
                <template v-else>
                    <sub-menu :key="item.key" :menu-info="item"/>
                </template>
            </template>
        </a-menu>
    </div>
</template>

<script setup>
    import {ref,reactive,toRefs,computed,watch} from 'vue';
    import {useRoute} from 'vue-router';
    import SubMenu from './SubMenu.vue';
    import Mock from '../mock.json';
    
    const route = useRoute()
    const props = defineProps({
        isCollapsed:{
            type:Boolean
        }
    })

    const role = ref(localStorage.getItem('hd_ota_loginUser')? JSON.parse(localStorage.getItem('hd_ota_loginUser')).role_type : '') // 当前登录人角色
    const menu_data = ref([])

    watch(
        ()=>route.path,
        ()=>{
            state.selectedKeys = [`${route.name}`]
            state.openKeys = route.matched.length > 2? route.matched[route.matched.length - 1].path.split('/') : []
        }
    )
    
    // 渲染菜单
    const list = computed(()=>{
        function getMenu(data,index){
            return data.map(item=>{
                if(item.children && item.children.length > 0){
                    item.children = getMenu(item.children,index + 1)
                }
                
                return { 
                    ...item,
                    key: item.name,
                    title: item && item.meta && item.meta.title,
                    title_lang: item && item.meta && item.meta.lang,
                    link:item.path,
                    icon: item && item.meta && item.meta.icon,
                }
            })
        }

        Mock.data.forEach(i=>{
            if(i.auth && i.auth.includes(role.value)){
                menu_data.value.push(i)
            }
        })
        console.log(menu_data.value,'menu_data')

        return getMenu(menu_data.value,0)
    })
    // console.log(list,'list')
    
    // 菜单高亮及展开
    const state = reactive({
        rootSubmenuKeys: list.value.map(item=>item.name),
        openKeys: route.matched.length > 2? route.matched[route.matched.length - 1].path.split('/') : [],// 展开子级菜单项
        selectedKeys: [`${route.name}`],// 默认高亮菜单项
    });

    function clickMenuItem(){}
    
    const onOpenChange = (val) => {
        console.log(val,'vvvvvvv',route)
        const latestOpenKey = val.find(key => state.openKeys.indexOf(key) === -1)
        if (state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            state.openKeys = val
        } else {
            state.openKeys = latestOpenKey ? [latestOpenKey] : []
        } 
    };


</script>

<style lang="scss" scoped>

</style>